import React from 'react';
import { motion } from 'framer-motion';
import GameWithVideo from './GameWithVideo';

interface GameProps {
  isOpen: boolean;
  onClose: () => void;
}

const Game: React.FC<GameProps> = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <motion.div
      className="fixed inset-0 z-50 bg-[#2C2721] overflow-y-auto"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: 20 }}
      transition={{ duration: 0.6 }}
    >
      {/* Back Button */}
      <motion.div 
        className="fixed top-8 left-8 z-[100]"
        initial={{ opacity: 0, x: -50 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.8, delay: 0.5 }}
      >
        <button
          onClick={onClose}
          className="text-[#F1EFE0] px-6 py-3 rounded-full border border-[#FFFFFF15] hover:border-[#C2442A] transition-all duration-300 flex items-center space-x-2"
          style={{ 
            background: 'linear-gradient(145deg, #2D2D2D, #3C3C3C)', 
            boxShadow: 'inset 0 2px 4px rgba(0,0,0,0.3), 0 4px 8px rgba(0,0,0,0.2)' 
          }}
        >
          <span>←</span>
          <span>Back</span>
        </button>
      </motion.div>

      {/* Game Content with Video */}
      <div className="relative w-full">
        <GameWithVideo />
      </div>
    </motion.div>
  );
};

export default Game;